import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaMenuItemModule } from '../area-menu-item/area-menu-item.module';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { UserInfoModule } from '../userInfo/user-info.module';
import { AreaMenuComponent } from './area-menu.component';

@NgModule({
    declarations: [
        AreaMenuComponent
    ],
    entryComponents: [
        AreaMenuComponent
    ],
    exports: [
        AreaMenuComponent
    ],
    imports: [
        CommonModule,
        AreaMenuItemModule,
        UserInfoModule
    ],
})
export class AreaMenuModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            AreaMenuComponent
        ]);
    }
}
